import React from 'react';
import { Badge } from '../../ui';

const GroupStats = ({ stats, title, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="bg-gray-50 rounded-lg p-4">
        <h4 className="text-sm font-medium text-gray-900 mb-2">{title}</h4>
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
          <div className="flex flex-wrap gap-1">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="h-6 bg-gray-200 rounded w-16"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const getCategoryColor = (category) => {
    const colors = {
      crypto: 'yellow',
      tech: 'blue', 
      business: 'green',
      finance: 'purple',
      gaming: 'red',
      education: 'indigo',
      entertainment: 'pink',
      news: 'gray',
      other: 'gray'
    };
    return colors[category.toLowerCase()] || 'gray';
  };

  const formatCategoryLabel = (category) => {
    return category.charAt(0).toUpperCase() + category.slice(1);
  };

  const totalGroups = stats.total_groups || stats.total_available || 0;
  const categories = stats.categories || {};
  const assignmentTypes = stats.assignment_types || {};

  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <h4 className="text-sm font-medium text-gray-900 mb-2">{title}</h4>
      
      {/* Total count */}
      <div className="mb-3">
        <span className="text-lg font-semibold text-gray-900">
          {totalGroups.toLocaleString()} Groups
        </span>
      </div>

      {Object.keys(assignmentTypes).length > 0 && (
        <div className="mb-3 flex flex-wrap gap-1">
          {Object.entries(assignmentTypes).map(([type, count]) => (
            <Badge key={type} variant={type === 'automatic' ? 'blue' : 'gray'} size="sm">
              {type}: {count}
            </Badge>
          ))}
        </div>
      )}
      
      {/* Category breakdown */}
      {Object.keys(categories).length > 0 ? (
        <div className="space-y-2">
          <div className="text-xs font-medium text-gray-700 mb-1">
            Category Breakdown:
          </div>
          <div className="flex flex-wrap gap-1">
            {Object.entries(categories)
              .sort(([,a], [,b]) => b - a) // Sort by count descending
              .map(([category, count]) => (
                <Badge 
                  key={category}
                  variant={getCategoryColor(category)}
                  size="sm"
                >
                  {formatCategoryLabel(category)}: {count}
                </Badge>
              ))
            }
          </div>
        </div>
      ) : (
        <div className="text-xs text-gray-500">
          No category breakdown available
        </div>
      )}
    </div>
  );
};

export default GroupStats;
